<template>
  <div>
    <portal-target
      v-show="showList"
      name="layout-main"
      class="layout-main panel-scroll-full"
    >
      <div class="panel-list panel-fixed">
        <div class="panel-header">
          <h1 class="page-header mr-2 d-flex align-items-center">
            {{ titleWithYardName | translate }}
          </h1>
          <ol class="breadcrumb pull-right">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'dashboard'}">
                {{"Dashboard"}}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: YARD_ROUTES.YARD_LIST }">
                {{$t("Yards")}}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: YARD_ROUTES.YARD_DETAIL, params: { id: $route.params.id } }">
                {{$t("Yard")}}
              </router-link>
            </li>
            <li class="breadcrumb-item">{{ title | translate }}</li>
          </ol>
        </div>
        <component-edit
          v-if="showEditForm && editComponent"
          :controlBodies="list.results"
          :yard="$route.params.id"
          :editParams="editParams"
          @on-submit="refreshListAfterSubmit"
          @close-form='closeEditForm'
        />

        <advanced-search
          v-show="showAdvancedSearch"
          v-if="toggleAdvancedSearch"
          :fields="searchFields"
          :reset="reset"
          @search="addFiltersToInstance"
          @reset="removeFiltersToInstance"
          @active="activeFilters = $event"
        />
        <panel :title="title" :no-button="true">
          <thux-list-component
            :fields="getFields"
            :pagination="getPaginationFields"
            @select-per-page="changePerPage"
            @change-page="changePage"
            :action-select="getActionSelectFields"
            @select-action="setAction"
            @select-or-deselect-all-queryset="selectOrDeselectAllQueryset"
            @do-action="doAction($event, fieldName)"
            :advanced-search="getAdvancedSearchFields"
            @show-advanced-search="openAdvancedSearch"
            @open-edit-form="openEditForm()"
            @open-detail-form="openDetailForm()"
          >
            <template slot="body">
              <component-table
                :list="list.results"
                :goBack="goBack"
                :params="tableParams"
                @open-edit-form="openEditForm"
                @open-detail-form="openDetailForm"
                @refresh-list="refreshListAfterSubmit"
              />
            </template>
          </thux-list-component>
        </panel>
      </div>
    </portal-target>
    <router-view />
    <portal-target
      v-if="showCommonFilters"
      v-show="showList"
      name="layout-sidebar"
      class="layout-side panel-scroll-full"
    >
      <button
        @click.prevent="closeRightSidebar"
        class="btn btn-primary text-uppercase w-100 mb-4"
        :aria-label="$t('Close')"
      >
        <i class="fas fa-times" />
        {{ $t('Hide sidebar') }}
      </button>
      <common-filters />
    </portal-target>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { ROUTES as YARD_ROUTES } from '../router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../../components/thux-list/ThuxListMixin'

import YardControlBodiesTable from './YardControlBodiesTable'
import YardControlBodyEdit from './YardControlBodyEdit'
import { TYPES as YARD_CONTROL_BODY_TYPES } from '../../yard-control-body/store'
import { TYPES as YARD_TYPES } from '../store'

export default {
  name: 'YardControlBodiesList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': YardControlBodiesTable,
    'component-edit': YardControlBodyEdit
  },
  data () {
    return {
      YARD_ROUTES,
      title: this.$t('Control bodies'),
      rolePerm: ['yard_yardcontrolbody_list'],
      actionEnablePermission: ['yard_yardcontrolbody_enable'],
      actionDisablePermission: ['yard_yardcontrolbody_disable'],
      showCommonFilters: false,
      searchFields: [
        { key: 'filter__contact__first_name__icontains', placeholder: this.$t('First name'), type: 'text', col: 4 },
        { key: 'filter__contact__last_name__icontains', placeholder: this.$t('Last name'), type: 'text', col: 4 }
      ]
    }
  },
  created () {
    this.yardRetrieve({ id: this.$route.params.id })
  },
  computed: {
    ...mapGetters({
      ...YARD_CONTROL_BODY_TYPES.GENERIC.yard.yardcontrolbody.LIST.GETTERS,
      yardDetail: YARD_TYPES.GENERIC.yard.yard.DETAIL.GETTERS.detail
    }),
    titleWithYardName () {
      if (this.yardDetail && this.yardDetail.code) {
        return `${this.$t('Control bodies')} ${this.yardDetail.name ? this.yardDetail.name : this.yardDetail.customer_name} (${this.yardDetail.code})`
      }
      if (this.list && this.list.results && this.list.results.length > 0) {
        const yardName = this.list.results[0].yard_name ? `(${this.list.results[0].yard_name})` : ''
        return `${this.$t('Control bodies')} ${yardName}`
      }
      return this.$t('Control bodies')
    },
    showList () {
      return hasPerm('yard_yardcontrolbody_list')
    },
    canSeeActionSelect () {
      return false
    },
    canAddInstance () {
      return hasPerm('yard_yardcontrolbody_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: YARD_CONTROL_BODY_TYPES.GENERIC.yard.yardcontrolbody.LIST.MUTATIONS.setSelectedList,
      setSelectAll: YARD_CONTROL_BODY_TYPES.GENERIC.yard.yardcontrolbody.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...YARD_CONTROL_BODY_TYPES.GENERIC.yard.yardcontrolbody.LIST.ACTIONS,
      yardRetrieve: YARD_TYPES.GENERIC.yard.yard.DETAIL.ACTIONS.retrieve
    }),
    getComponentList () {
      this.setFilters({ filter__yard_id: this.$route.params.id })
    },
    refreshListAfterSubmit () {
      this.getComponentList()
      this.closeEditForm()
    },
    closeEditForm () {
      this.$set(this, 'showDetailForm', false)
      this.$set(this, 'showEditForm', false)
    }
  }
}
</script>
